export default __webpack_public_path__ + "static/media/blog3.c50159aa.jpeg";